import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import { isEmpty, isEnabled } from '../modules/appLibrary';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import { setlayout,setstartup } from '../modules/toolpanelstore';
import { setsearchlayout, setsearchstartup} from '../modules/searchliststore';
import TextField from '@material-ui/core/TextField';

export default function CustomToolorgPanel(props) {
    const mainlayout = useSelector(state => state.toolpnl.layouts);         //Main List
    const mainprelayout = useSelector(state => state.toolpnl.prelayout);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout);
    const mainshowlimit = useSelector(state => state.toolpnl.showlimit);
    const searchlayout = useSelector(state => state.search.layouts);        //Search List
    const searchprelayout = useSelector(state => state.search.prelayout);
    const searchinitlayout = useSelector(state => state.search.initlayout);
    const searchshowlimit = useSelector(state => state.search.showlimit);
    const dispatch = useDispatch();

    const [layouts, setlayouts] = useState([{ value: ' ', label: '既定レイアウト' }]);
    const [layoutname, setlayoutname] = useState('');
    const [expandsave, setexpandsave] = useState(false);

    useEffect(() => {
        if (isEmpty(mainlayout) || Number(props.type)===1000) return;
        var layouts = mainlayout.filter(function (val) { return val.value !== ' '; });
        setlayouts(layouts);
    }, [mainlayout]);

    useEffect(() => {
        if (isEmpty(searchlayout) || Number(props.type) !== 1000) return;
        var layouts = searchlayout.filter(function (val) { return val.value !== ' '; });
        setlayouts(layouts);
    }, [searchlayout]);

    function savemenuexec() {
        if (isEmpty(layoutname)) {
            props.fnc.current.warnmsg("メニュタイトルを入力してください");
            return;
        }
        props.fnc.current.confmsg(["現在のレイアウトをメニュに登録します。よろしいですか？","メニュはマイアプリケーションリストに登録されます"], () => props.savelayout(1, layoutname));
    }
    function callexec(layout) {
        props.fnc.current.confmsg("レイアウトを「" + layout + "」に変更します。よろしいですか？", () => props.calllayout(layout));
    }
    function clearlayout() {
        props.fnc.current.confmsg("既定レイアウトに変更します。よろしいですか？", () => props.calllayout(' '));
    }
    function saveexec() {
        if (isEmpty(layoutname)) {
            props.fnc.current.warnmsg("レイアウト名を入力してください");
            return;
        }
        props.fnc.current.confmsg("現在のレイアウトを登録します。よろしいですか？", () => props.savelayout(0,layoutname));
    }
    function deletelayout(layoutid) {
        props.fnc.current.confmsg("レイアウト'" + layoutid + "'を削除します。よろしいですか？", () => DeleteLayout(layoutid));
    }
    //レイアウト削除
    function DeleteLayout(layoutid) {
        props.fnc.current.postaxios('common/DeleteLayout',
            {
                "controller": props.dataid, "subkey": props.subkey, "type": props.type,
                "code": layoutid
            },
            {
                onSuccess: function (data) {
                    if (Number(props.type) !== 1000) {
                        let newlayout = mainlayout.filter(function (val) { return val.value !== layoutid; });
                        dispatch(setlayout(newlayout));
                        if (data.request !== maininitlayout)
                            dispatch(setstartup({
                                prelayout: mainprelayout,
                                initlayout: " ",
                                showlimit: mainshowlimit
                            }));
                   } else {
                        let newlayout = searchlayout.filter(function (val) { return val.value !== layoutid; });
                        dispatch(setsearchlayout(newlayout));
                        if (data.request !== searchinitlayout)
                            dispatch(setsearchstartup({
                                prelayout: searchprelayout,
                                initlayout: " ",
                                showlimit: searchshowlimit
                            }));
                    }
                    props.fnc.current.success();
                    props.fnc.current.wait(false);
                },
            }
        )
    }

    return (
        <List
            style={{ width: 200 }}
            component="nav"
            dense={true}
            subheader={
                <ListSubheader component="div" id="nested-list-subheader">
                    レイアウト管理
                </ListSubheader>
            }
         >
            <ListItem button onClick={() => setexpandsave(!expandsave)}>
                <ListItemText primary="現在のレイアウトを登録" />
            </ListItem>
            <Collapse in={expandsave} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <ListItem>
                        <Button variant="outlined" size="small" onClick={saveexec}>ﾚｲｱｳﾄ登録</Button>
                        {isEnabled(props.entryform) ? null :
                            null
                        //    <Button variant="outlined" size="small" onClick={savemenuexec}>ﾒﾆｭ登録</Button> 保留
                        }
                    </ListItem>
                    <ListItem>
                        {isEnabled(props.entryform) ?
                            <TextField label="レイアウト名" size="small" inputProps={{ maxLength: 30 }} fullWidth onChange={(e) => setlayoutname(e.target.value)} />
                            :
                            <TextField label="レイアウト名" size="small" inputProps={{ maxLength: 30 }} fullWidth onChange={(e) => setlayoutname(e.target.value)} />
                        //    <TextField label="ﾚｲｱｳﾄ名またはﾒﾆｭﾀｲﾄﾙ" size="small" inputProps={{ maxLength: 30 }} fullWidth onChange={(e) => setlayoutname(e.target.value)} />　保留
                        }
                    </ListItem>
                </List>
            </Collapse>
            <Divider />
            <ListItem button onClick={clearlayout}>
                <ListItemText primary="既定レイアウトに戻す" />
            </ListItem>
            <Divider />
            <ListItem>
                <ListItemText primary="登録レイアウト" />
            </ListItem>
            {layouts.map((option) => (
                <ListItem>
                    <Button style={{ justifyContent: "flex-start" }} fullWidth={true} size="small" onClick={() => callexec(option.value)}>{option.value}</Button >
                    <IconButton edge="end" size="small" title="削除" onClick={() => deletelayout(option.value)} style={{ marginLeft:5 }}>
                        <Icon>delete</Icon>
                    </IconButton>
                </ListItem>
            ))}
         </List>
    );
};